'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var FailureAlert = function FailureAlert() {
  return React__default["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "240",
    height: "240",
    viewBox: "0 0 240 240"
  }, React__default["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default["default"].createElement("g", null, React__default["default"].createElement("g", {
    fill: "#D81B60",
    fillOpacity: ".04"
  }, React__default["default"].createElement("path", {
    d: "M168 201c0 3.313-24.848 6-55.5 6S57 204.313 57 201s24.848-6 55.5-6 55.5 2.687 55.5 6M127.475 31.32C109.014 18.703 89.9 5.8 67.988 1.37 46.075-3.063 20.425 3.122 8.342 21.95.351 34.4-.523 50.066.206 64.847.602 72.89 1.429 81.034 4.342 88.54c12.283 31.657 55.32 40.427 72.079 69.953 3.484 6.135 5.769 13.095 10.593 18.24 10.836 11.552 29.917 9.505 44.316 2.925 14.401-6.58 27.477-16.82 43.075-19.525 18.276-3.17 41.38 2.887 52.366-12.076 7.863-10.71 3.649-26.118-3.589-37.262-11.585-17.838-29.44-30.474-46.858-42.664-19.776-13.841-31.847-24.896-51.623-38.738",
    transform: "translate(5.5 16.5)"
  })), React__default["default"].createElement("g", {
    stroke: "#000",
    strokeOpacity: ".87",
    transform: "translate(5.5 16.5) translate(49 17)"
  }, React__default["default"].createElement("circle", {
    cx: "63",
    cy: "73",
    r: "63",
    fill: "#FFF",
    strokeWidth: "3"
  }), React__default["default"].createElement("g", {
    fill: "#D81B60",
    strokeWidth: "2",
    transform: "translate(54)"
  }, React__default["default"].createElement("path", {
    d: "M0 0H18V84H0z"
  }), React__default["default"].createElement("circle", {
    cx: "9",
    cy: "102",
    r: "9"
  })))), React__default["default"].createElement("path", {
    d: "M0 0H240V240H0z"
  })));
};

module.exports = FailureAlert;
